import {queryAll, queryOne, command, querySearch} from "../utils/api";

const GET_PURCHASE_ORDERS_URL = `${process.env.PUBLIC_URL}/api/v1/r/purchaseOrders`;

export const SEARCH_PURCHASE_ORDERS = 'SEARCH_PURCHASE_ORDERS';
export const SEARCH_PURCHASE_ORDERS_COMPLETED = 'SEARCH_PURCHASE_ORDERS_COMPLETED';
export const SEARCH_PURCHASE_ORDERS_FAILED = 'SEARCH_PURCHASE_ORDERS_FAILED';
export const searchPurchaseOrders = querySearch(GET_PURCHASE_ORDERS_URL, SEARCH_PURCHASE_ORDERS,
  SEARCH_PURCHASE_ORDERS_COMPLETED, SEARCH_PURCHASE_ORDERS_FAILED, 'supplierName');

export const GET_PURCHASE_ORDERS = 'GET_PURCHASE_ORDERS';
export const GET_PURCHASE_ORDERS_COMPLETED = 'GET_PURCHASE_ORDERS_COMPLETED';
export const GET_PURCHASE_ORDERS_FAILED = 'GET_PURCHASE_ORDERS_FAILED';
export function getPurchaseOrders({dispensaryId, status}) {
  const filter = {
    where: {dispensaryId}
  };
  if (status) {
    if (Array.isArray(status)) {
      status = {inq: status};
    }
    filter.where.status = status;
  }
  return queryAll(GET_PURCHASE_ORDERS_URL, filter, GET_PURCHASE_ORDERS, GET_PURCHASE_ORDERS_COMPLETED,
    GET_PURCHASE_ORDERS_FAILED);
}

export const GET_PURCHASE_ORDER = 'GET_PURCHASE_ORDER';
export const GET_PURCHASE_ORDER_COMPLETED = 'GET_PURCHASE_ORDER_COMPLETED';
export const GET_PURCHASE_ORDER_FAILED = 'GET_PURCHASE_ORDER_FAILED';
export function getPurchaseOrder({purchaseId}) {
  const filter = {
    where: {purchaseId}
  };
  return queryOne(GET_PURCHASE_ORDERS_URL, filter, GET_PURCHASE_ORDER, GET_PURCHASE_ORDER_COMPLETED, GET_PURCHASE_ORDER_FAILED);
}

const COMMAND_URL = `${process.env.PUBLIC_URL}/api/v1/purchaseOrder`;
export const ADD_PURCHASE_ORDER = 'ADD_PURCHASE_ORDER';
export const ADD_PURCHASE_ORDER_COMPLETED = 'ADD_PURCHASE_ORDER_COMPLETED';
export const ADD_PURCHASE_ORDER_FAILED = 'ADD_PURCHASE_ORDER_FAILED';
export const addPurchaseOrder = command(COMMAND_URL + '/addPurchaseOrder', ADD_PURCHASE_ORDER,
  ADD_PURCHASE_ORDER_COMPLETED, ADD_PURCHASE_ORDER_FAILED);

export const ADD_PRODUCT_TO_PURCHASE_ORDER = 'ADD_PRODUCT_TO_PURCHASE_ORDER';
export const ADD_PRODUCT_TO_PURCHASE_ORDER_COMPLETED = 'ADD_PRODUCT_TO_PURCHASE_ORDER_COMPLETED';
export const ADD_PRODUCT_TO_PURCHASE_ORDER_FAILED = 'ADD_PRODUCT_TO_PURCHASE_ORDER_FAILED';
export const addProductToPurchaseOrder = command(COMMAND_URL + '/addProductToPurchaseOrder',
  ADD_PRODUCT_TO_PURCHASE_ORDER, ADD_PRODUCT_TO_PURCHASE_ORDER_COMPLETED, ADD_PRODUCT_TO_PURCHASE_ORDER_FAILED);

export const REMOVE_PRODUCT_FROM_PURCHASE_ORDER = 'REMOVE_PRODUCT_FROM_PURCHASE_ORDER';
export const REMOVE_PRODUCT_FROM_PURCHASE_ORDER_COMPLETED = 'REMOVE_PRODUCT_FROM_PURCHASE_ORDER_COMPLETED';
export const REMOVE_PRODUCT_FROM_PURCHASE_ORDER_FAILED = 'REMOVE_PRODUCT_FROM_PURCHASE_ORDER_FAILED';
export const removeProductFromPurchaseOrder = command(COMMAND_URL + '/removeProductFromPurchaseOrder',
  REMOVE_PRODUCT_FROM_PURCHASE_ORDER, REMOVE_PRODUCT_FROM_PURCHASE_ORDER_COMPLETED, REMOVE_PRODUCT_FROM_PURCHASE_ORDER_FAILED);

export const UPDATE_PURCHASE_ORDER_PRODUCT = 'UPDATE_PURCHASE_ORDER_PRODUCT';
export const UPDATE_PURCHASE_ORDER_PRODUCT_COMPLETED = 'UPDATE_PURCHASE_ORDER_PRODUCT_COMPLETED';
export const UPDATE_PURCHASE_ORDER_PRODUCT_FAILED = 'UPDATE_PURCHASE_ORDER_PRODUCT_FAILED';
export const updatePurchaseOrderProduct = command(COMMAND_URL + '/updatePurchaseOrderProduct',
  UPDATE_PURCHASE_ORDER_PRODUCT, UPDATE_PURCHASE_ORDER_PRODUCT_COMPLETED, UPDATE_PURCHASE_ORDER_PRODUCT_FAILED);

export const SUBMIT_PURCHASE_ORDER = 'SUBMIT_PURCHASE_ORDER';
export const SUBMIT_PURCHASE_ORDER_COMPLETED = 'SUBMIT_PURCHASE_ORDER_COMPLETED';
export const SUBMIT_PURCHASE_ORDER_FAILED = 'SUBMIT_PURCHASE_ORDER_FAILED';
export const submitPurchaseOrder = command(COMMAND_URL + '/submitPurchaseOrder', SUBMIT_PURCHASE_ORDER,
  SUBMIT_PURCHASE_ORDER_COMPLETED, SUBMIT_PURCHASE_ORDER_FAILED);

export const CONFIRM_PURCHASE_ORDER = 'CONFIRM_PURCHASE_ORDER';
export const CONFIRM_PURCHASE_ORDER_COMPLETED = 'CONFIRM_PURCHASE_ORDER_COMPLETED';
export const CONFIRM_PURCHASE_ORDER_FAILED = 'CONFIRM_PURCHASE_ORDER_FAILED';
export const confirmPurchaseOrder = command(COMMAND_URL + '/confirmPurchaseOrder', CONFIRM_PURCHASE_ORDER,
  CONFIRM_PURCHASE_ORDER_COMPLETED, CONFIRM_PURCHASE_ORDER_FAILED);

export const RECEIVE_PURCHASE_ORDER = 'RECEIVE_PURCHASE_ORDER';
export const RECEIVE_PURCHASE_ORDER_COMPLETED = 'RECEIVE_PURCHASE_ORDER_COMPLETED';
export const RECEIVE_PURCHASE_ORDER_FAILED = 'RECEIVE_PURCHASE_ORDER_FAILED';
export const receivePurchaseOrder = command(COMMAND_URL + '/receivePurchaseOrder', RECEIVE_PURCHASE_ORDER,
  RECEIVE_PURCHASE_ORDER_COMPLETED, RECEIVE_PURCHASE_ORDER_FAILED);

export const CANCEL_PURCHASE_ORDER = 'CANCEL_PURCHASE_ORDER';
export const CANCEL_PURCHASE_ORDER_COMPLETED = 'CANCEL_PURCHASE_ORDER_COMPLETED';
export const CANCEL_PURCHASE_ORDER_FAILED = 'CANCEL_PURCHASE_ORDER_FAILED';
export const cancelPurchaseOrder = command(COMMAND_URL + '/cancelPurchaseOrder', CANCEL_PURCHASE_ORDER,
  CANCEL_PURCHASE_ORDER_COMPLETED, CANCEL_PURCHASE_ORDER_FAILED);



// WEBPACK FOOTER //
// ./src/PurchaseOrder/actions.js